import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, inject, OnInit, signal, viewChild, ViewChild } from '@angular/core';
import { PiasLayoutComponent } from '../../shared/components/pias-layout/pias-layout.component';
import { SessionStorageService } from '../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../shared/services/snackbar/snackbar.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SelectOptions } from '../../core/interfaces/select-options.interface';
import { MatDividerModule } from '@angular/material/divider';
import { GetDownloadResourceListModel } from '../../core/models/get-download-resource-list/get-download-resource-list.model';
import { HttpStatusCode } from 'axios';
import { DownloadResourceList } from '../../core/interfaces/download-resource-list-v2.interface';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { UserLogService } from '../../core/services/user-log/user-log.service';
import { Router } from '@angular/router';
import { ConstantsService } from '../../core/services/constants/constants.service';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { DownloadResourceCategory } from '../../core/interfaces/download-resource-category-v2.interface';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { DownloadResourcesServiceV2 } from '../../core/services/download-resources-v2/download-resources-v2.service';
type View = 'root' | 'split' | 'client' | 'event' | 'files';
@Component({
  selector: 'app-download-resources',
  imports: [
    CommonModule,
    PiasLayoutComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDividerModule,
    MatPaginatorModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
  ],
  templateUrl: './download-resources-v2.page.html',
  styleUrl: './download-resources-v2.page.scss',
  host: {
    '(document:keydown.escape)': 'onEscape()',
    '(document:fullscreenchange)': 'syncFullscreenState()',
  }
})
export class DownloadResourcesPageV2 implements OnInit, AfterViewInit {
  private router = inject(Router);
  private sanitizer = inject(DomSanitizer);
  private formBuilder = inject(FormBuilder);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private downloadResourcesService = inject(DownloadResourcesServiceV2);
  private userLogService = inject(UserLogService);
  private constantsService = inject(ConstantsService);

  protected downloadResourceCategoryOptions: SelectOptions[] = [];
  protected getDownloadResourceListModel = new GetDownloadResourceListModel();
  protected resourceCategoryList: DownloadResourceCategory[] = [];
  protected resourceCategoryListDataSource: DownloadResourceCategory[] = [];
  protected resourceCategoryListSelectionPath: DownloadResourceCategory[] = [];
  protected downloadResourceListDataSource: DownloadResourceList[] = [];
  protected downloadResourceList: DownloadResourceList[] = [];
  protected tempDownloadResourceList: DownloadResourceList[] = [];
  protected downloadResourcePageSize: number = 10;
  protected downloadResourceCurrentPage: number = 0;
  protected downloadResourceLength: number = 0;
  protected selectedCategoryId: string = '6abcd8fcd3cd3dcba69441e2';

  private readonly previewPanel = viewChild<ElementRef<HTMLElement>>('previewPanel');

  selectedDocument!: SafeResourceUrl;
  /** Preview panel state. */
  showPreview = false;
  isFullscreen = false;
  currentFileName!: string;

  private readonly ROOT_RESOURCE_CATEGORY: DownloadResourceCategory = {
    applicationid: "65f9cf2323d1058bd69ae463",
    applicationname: "PIAS",
    folderid: "6abcd8fcd3cd3dcba69441e2",
    location: "PIAS:/Standard Documents",
    name: "Standard Documents",
    parentFolderid: ""
  };


  protected setResourceListSprinner = signal(false);
  protected categoryIdSelection = signal('6abcd8fcd3cd3dcba69441e2');
  protected isCategoryListNotEmpty = signal(false);

  @ViewChild(MatPaginator)
  downloadResourcePaginator!: MatPaginator;

  downloadResourceFg!: FormGroup;

  constructor() { }

  async ngOnInit(): Promise<void> {
    this.downloadResourceFg = this.formBuilder.group({
      searchKeyword: [''],
      // drCategory: ['']
    });

    this.resourceCategoryListSelectionPath.push(this.ROOT_RESOURCE_CATEGORY);

    await this.getDownloadResourceList();
    this.__applyDownloadResourceCategoryListFilter('6abcd8fcd3cd3dcba69441e2');

    this.__applyDownloadResourceFilter();
  }

  ngAfterViewInit(): void { }

  // async getdownloadResourceCategoryList() {
  //   // const responseData = await this.constantsService
  //   //   .getConstantsList()
  //   //   .then((response) => {
  //   //     return JSON.parse(response);
  //   //   })
  //   //   .catch((error) => {
  //   //     // console.error(error);
  //   //     return error;
  //   //   });

  //   // const categoryList: any[] = responseData.data.responsedata.categories;

  //   // this.downloadResourceCategoryOptions = [];
  //   // categoryList.forEach((category) => {
  //   //   this.downloadResourceCategoryOptions.push({
  //   //     name: category,
  //   //     value: category
  //   //   });
  //   // });

  //   const responseData = await this.downloadResourcesService
  //     .getDownloadResourceCategoryList()
  //     .then((response) => {
  //       return JSON.parse(response);
  //     })
  //     .catch((error) => {
  //       return error;
  //     });

  //   if (responseData.status === HttpStatusCode.Ok) {
  //     this.resourceCategoryList = responseData.data.responsedata;
  //   } else {
  //     if (responseData.code === HttpStatusCode.BadRequest) {
  //       // Display notification on API failure.
  //       this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
  //     }
  //     if (responseData.code === HttpStatusCode.Unauthorized) {
  //       this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
  //       this.router.navigate(['/login']);
  //     }

  //     this.sessionStorageService.clearSessionStorage();
  //   }

  //   this.__applyDownloadResourceCategoryListFilter('');

  //   await this.getDownloadResourceList();
  // }

  async getDownloadResourceList() {
    this.setResourceListSprinner.set(true);

    const responseData = await this.downloadResourcesService
      .getDownloadResourceList()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setResourceListSprinner.set(false);

    // Handling the response from the API call.
    if (responseData.status === HttpStatusCode.Ok) {
      // this.downloadResourceList = responseData.data.responsedata.getallresourcecategoryrow;
      this.resourceCategoryList = responseData.data.responsedata.folderlist.filter((item: DownloadResourceCategory) => !['Client Documents', 'test'].includes(item.name));
      let drList: DownloadResourceList[] = responseData.data.responsedata.documentlist.items;

      drList.forEach((item) => {
        item.resourceCategoryPath = this.__getCategoryPath(item);
      });

      this.downloadResourceList = drList;

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }

      this.sessionStorageService.clearSessionStorage();
    }
  }

  protected async __onCategorySelection(category: DownloadResourceCategory) {
    this.categoryIdSelection.set(category.folderid);
    this.selectedCategoryId = category.folderid;
    this.__applyDownloadResourceCategoryListFilter(this.selectedCategoryId);

    this.resourceCategoryListSelectionPath = this.__getCategoryAncestry(category.folderid);

    // await this.getDownloadResourceList(category.resourceCategoryId);
    this.__applyDownloadResourceFilter();
  }

  /**
   * Builds the folder chain from the "Standard Documents" root down to the given folder.
   * Shared by the path pills and each document's resourceCategoryPath so both always match.
   */
  private __getCategoryAncestry(folderId: string): DownloadResourceCategory[] {
    const rootFolderId = this.ROOT_RESOURCE_CATEGORY.folderid;
    const ancestry: DownloadResourceCategory[] = [];
    const visitedFolderIds = new Set<string>();
    let currentFolderId = folderId;

    // Stop at the root, at an unknown folder, or on a cycle — never loop forever.
    while (currentFolderId && currentFolderId != rootFolderId && !visitedFolderIds.has(currentFolderId)) {
      visitedFolderIds.add(currentFolderId);
      const currentCategory = this.resourceCategoryList.find(item => item.folderid == currentFolderId);
      if (!currentCategory) {
        break;
      }
      ancestry.push(currentCategory);
      currentFolderId = currentCategory.parentFolderid;
    }

    ancestry.push(this.ROOT_RESOURCE_CATEGORY);
    return ancestry.reverse();
  }

  protected __getCategoryPath(drItem: DownloadResourceList): string {
    return this.__getCategoryAncestry(drItem.parentFolderId)
      .map(category => category.name)
      .join(' › ');
  }

  protected __applyDownloadResourceCategoryListFilter(parentCategoryId: string) {
    this.resourceCategoryListDataSource = this.resourceCategoryList.filter((item) => item.parentFolderid == parentCategoryId);
    if (this.resourceCategoryListDataSource.length != 0) {
      this.isCategoryListNotEmpty.set(true);
    } else {
      this.isCategoryListNotEmpty.set(false);
    }
  }

  protected __applyDownloadResourceFilter() {
    let searchKeyword: string = this.downloadResourceFg.get('searchKeyword')?.value.toString();

    let targetCategoryIds: string[] = [this.selectedCategoryId];

    this.resourceCategoryList.forEach((category) => {
      if (targetCategoryIds.includes(category.parentFolderid)) {
        targetCategoryIds.push(category.folderid);
      }
    });

    let targetDownloadResources: DownloadResourceList[] = this.downloadResourceList
      .filter((item) => (targetCategoryIds.includes(item.parentFolderId)));

    if (searchKeyword) {
      this.tempDownloadResourceList = targetDownloadResources
        .filter(drItem =>
          drItem.documentName.toLowerCase().includes(searchKeyword.toLowerCase())
          || drItem.groupName.toLowerCase().includes(searchKeyword.toLowerCase())
          // || drItem.documentTypeName.toLowerCase().includes(searchKeyword.toLowerCase())
        );
    } else {
      this.tempDownloadResourceList = targetDownloadResources;
    }

    this.downloadResourcePaginator.firstPage();
    this.__downloadResourceUpdatePageItems();
  }

  protected __downloadResourceUpdatePageItems() {
    const startIndex: number = this.downloadResourceCurrentPage * this.downloadResourcePageSize;
    const endIndex: number = startIndex + this.downloadResourcePageSize;
    this.downloadResourceLength = this.tempDownloadResourceList.length;

    if (this.downloadResourceLength < this.downloadResourcePageSize) {
      this.downloadResourcePaginator.disabled = true;
    }
    else {
      this.downloadResourcePaginator.disabled = false;
    }

    this.downloadResourceListDataSource = this.tempDownloadResourceList.slice(startIndex, endIndex);
  }

  protected __downloadResourceOnPageChange() {
    this.downloadResourcePageSize = this.downloadResourcePaginator.pageSize;
    this.downloadResourceCurrentPage = this.downloadResourcePaginator.pageIndex;
    this.__downloadResourceUpdatePageItems();
  }

  protected __getFileType(resourceLink: string) {
    let fileUrlName: string[] = resourceLink.split(".");
    return fileUrlName[fileUrlName.length - 1];
  }

  protected async __userLogDocument(resourceId: number, resourceLink: string) {
    let fileUrlName: string[] = resourceLink.split("/");
    await this.downloadResourcesService.downloadResourceFile(resourceId, fileUrlName[fileUrlName.length - 1]);
    await this.userLogService.logUserDownloadResource(fileUrlName[fileUrlName.length - 1]);
  }

  protected convertDate(dateStr: string): Date {
    const [datePart, timePart] = dateStr.split(' ');
    const [day, month, year] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  protected clearSearch() {
    this.downloadResourceFg.get('searchKeyword')?.setValue('');
    this.__applyDownloadResourceFilter();
  }

  async __previewDownloadResource(drItem: DownloadResourceList): Promise<void> {

    this.showPreview = true;
    // this.selectedDocument = '';

    try {

      const blob = await this.downloadResourcesService.previewdownloadResourceFile(drItem.documentId)
        .then((response) => {
          return JSON.parse(response);
        })
        .catch((error) => {
          // console.error(error);
          return error;
        });
      const fileURL = blob.data.responsedata.location;
      this.selectedDocument = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
      this.currentFileName = drItem.documentName;
    } catch (error) {
      console.error(error);
    }
  }

  async toggleFullscreen(): Promise<void> {
    const panel = this.previewPanel()?.nativeElement;
    if (!panel) {
      return;
    }

    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      } else {
        await panel.requestFullscreen();
      }
    } catch (error) {
      console.error(error);
    }
  }

  syncFullscreenState(): void {
    this.isFullscreen = !!this.previewPanel()
      && document.fullscreenElement === this.previewPanel()!.nativeElement;
  }

  onEscape(): void {
    // In full screen the browser handles Escape itself — don't also close the panel.
    if (this.isFullscreen || !this.showPreview) {
      return;
    }

    this.closePreview();
  }

  closePreview(): void {
    if (document.fullscreenElement) {
      document.exitFullscreen().catch((error) => console.error(error));
    }

    this.showPreview = false;
    // this.selectedDocument = '';

  }

  protected async __printDownloadResource(resourceId: number) {
    await this.downloadResourcesService.printPdf(resourceId);
  }

  onPillClick(event: MouseEvent, category: any) {
    event.stopPropagation(); //  block accordion toggle
    this.__onCategorySelection(category);
  }

}


